module.exports = __webpack_public_path__ + "img/s_top_06.4d511b51.png";